import { Outlet } from "react-router";

export function PublicLayout() {
  return <Outlet />;
}
